import './header.style.css'
import Cta from '../cta/Cta.component'
import Social from '../socials/socials.component'
import Meta from '../meta/meta.component'

const Header = () => {
  return (
    <header id='header'>
      <Meta />
      <div className="container">
        <h5>Hello I'am</h5>
        <h1>Vivek Padelkar</h1>
        <h5 className="text-light">Full Stack Developer</h5>

        <Cta />

        <Social />

        <div className="me">
          <img src={'/assets/profile_no_bg.png'} alt="vivek padelkar" />
        </div>

        <a href="#contact" className="scroll_down">
          All the way down
        </a>
      </div>
    </header>
  )
}

export default Header
